import React from 'react';
import { Camera } from 'lucide-react';

const CameraModal = ({
    showCamera,
    capturedImage,
    videoRef,
    cameraStream,
    setCameraStream,
    setCapturedImage,
    onClose,
    onUsePhoto
}) => {
    const handleCameraCapture = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: { width: 640, height: 480 }
            });
            setCameraStream(stream);
            if (videoRef.current) {
                videoRef.current.srcObject = stream;
            }
        } catch (error) {
            console.error('Error accessing camera:', error);
            alert('Could not access camera. Please check permissions.');
            onClose();
        }
    };

    const capturePhoto = () => {
        const video = videoRef.current;
        if (!video) return;

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.width = 190;
        canvas.height = 190;

        const videoWidth = video.videoWidth;
        const videoHeight = video.videoHeight;
        const size = Math.min(videoWidth, videoHeight);
        const x = (videoWidth - size) / 2;
        const y = (videoHeight - size) / 2;

        context.drawImage(video, x, y, size, size, 0, 0, 190, 190);

        canvas.toBlob((blob) => {
            setCapturedImage({
                blob: blob,
                dataUrl: canvas.toDataURL('image/jpeg', 0.9)
            });
        }, 'image/jpeg', 0.9);
    };

    const retakePhoto = async () => {
        setCapturedImage(null);
        await handleCameraCapture();
    };

    return (
        <div className="modal-overlay">
            <div className="camera-modal">
                <div className="camera-header">
                    <h3>Take Profile Photo</h3>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>

                <div className="camera-content">
                    {!capturedImage ? (
                        <div className="camera-preview">
                            <video
                                ref={videoRef}
                                autoPlay
                                playsInline
                                className="camera-video"
                            />
                            <div className="camera-controls">
                                <button className="capture-btn" onClick={capturePhoto}>
                                    <Camera size={24} />
                                    Capture
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className="photo-preview">
                            <img
                                src={capturedImage.dataUrl}
                                alt="Captured"
                                className="captured-photo"
                                style={{
                                    width: '190px',
                                    height: '190px',
                                    borderRadius: '50%',
                                    objectFit: 'cover'
                                }}
                            />
                            <div className="photo-controls">
                                <button className="retake-btn" onClick={retakePhoto}>
                                    Retake
                                </button>
                                <button className="use-photo-btn" onClick={() => onUsePhoto(capturedImage.blob)}>
                                    Use Photo
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CameraModal;